/** Печатные документы: staff. ky/en/uz — с теми же ключами (проверяется типом). */
import type { Shape } from "./shape";

export const ru = {
  branch: "Филиал",
  employee: "Сотрудник",
  position: "Должность",
  period: "Период",
  date: "Дата",
  status: "Статус",
  amount: "Сумма",
  total: "Итого",
  payrollSheet: "Платёжная ведомость",
  statement: "Ведомость",
  calculation: "Расчёт v{{v}} · {{status}}",
  payslip: "Расчётный листок",
  payslips: "Расчётные листки",
  allPayslips: "Все листки",
  component: "Вид",
  basis: "Основание",
  accrued: "Начислено",
  withheld: "Удержано",
  net: "К выплате",
  paid: "Выплачено",
  due: "Осталось выплатить",
  received: "Получил (подпись)",
  signAccountant: "Бухгалтер",
  signManager: "Руководитель",
  signEmployee: "Сотрудник",
  timesheet: "Табель учёта рабочего времени",
  shiftsJournal: "Журнал рабочих смен",
  worked: "Отработано, ч",
  night: "Ночные, ч",
  shifts: "Смен",
  clockIn: "Начало",
  clockOut: "Конец",
  breakMin: "Перерыв, мин",
  hoursNote: "Время — в часах и минутах (ч:мм); в Excel — часы десятичной дробью.",
  tipsSheet: "Ведомость распределения чаевых",
  tipsMode: "Способ распределения",
  tipsTotal: "Всего чаевых",
  unassigned: "Не распределено",
  payout: "Выплата",
  notPaid: "Не выплачено",
  employeesList: "Список сотрудников",
  hiredAt: "Дата приёма",
  phone: "Телефон",
  email: "Email",
  payScheme: "Схема оплаты",
  working: "Работает",
  dismissed: "Уволен {{date}}",
  auditLog: "Журнал аудита",
  auditAt: "Дата и время",
  action: "Действие",
  user: "Кто",
  object: "Объект",
  section: "Раздел",
  allSections: "Все разделы",
  pageN: "Страница {{n}}",
  leaderboard: "Рейтинг сотрудников",
  rank: "Место",
  metric: "Показатель",
  level: "Уровень",
  points: "Очки",
  allTime: "За всё время",
};

export const en: Shape<typeof ru> = {
  branch: "Branch",
  employee: "Employee",
  position: "Position",
  period: "Period",
  date: "Date",
  status: "Status",
  amount: "Amount",
  total: "Total",
  payrollSheet: "Payroll statement",
  statement: "Statement",
  calculation: "Calculation v{{v}} · {{status}}",
  payslip: "Payslip",
  payslips: "Payslips",
  allPayslips: "All payslips",
  component: "Type",
  basis: "Basis",
  accrued: "Accrued",
  withheld: "Withheld",
  net: "Net pay",
  paid: "Paid",
  due: "Left to pay",
  received: "Received (signature)",
  signAccountant: "Accountant",
  signManager: "Manager",
  signEmployee: "Employee",
  timesheet: "Working time sheet",
  shiftsJournal: "Work shift log",
  worked: "Worked, h",
  night: "Night, h",
  shifts: "Shifts",
  clockIn: "Start",
  clockOut: "End",
  breakMin: "Break, min",
  hoursNote: "Time is in hours and minutes (h:mm); in Excel — decimal hours.",
  tipsSheet: "Tip distribution statement",
  tipsMode: "Distribution method",
  tipsTotal: "Total tips",
  unassigned: "Not distributed",
  payout: "Payout",
  notPaid: "Not paid",
  employeesList: "Employee list",
  hiredAt: "Hire date",
  phone: "Phone",
  email: "Email",
  payScheme: "Pay scheme",
  working: "Employed",
  dismissed: "Dismissed {{date}}",
  auditLog: "Audit log",
  auditAt: "Date and time",
  action: "Action",
  user: "Who",
  object: "Object",
  section: "Section",
  allSections: "All sections",
  pageN: "Page {{n}}",
  leaderboard: "Employee leaderboard",
  rank: "Rank",
  metric: "Metric",
  level: "Level",
  points: "Points",
  allTime: "All time",
};

export const ky: Shape<typeof ru> = {
  branch: "Филиал",
  employee: "Кызматкер",
  position: "Кызмат орду",
  period: "Мезгил",
  date: "Күнү",
  status: "Абалы",
  amount: "Сумма",
  total: "Жыйынтык",
  payrollSheet: "Төлөм ведомосту",
  statement: "Ведомость",
  calculation: "Эсеп v{{v}} · {{status}}",
  payslip: "Эсептөө баракчасы",
  payslips: "Эсептөө баракчалары",
  allPayslips: "Бардык баракчалар",
  component: "Түрү",
  basis: "Негиз",
  accrued: "Эсептелди",
  withheld: "Кармалды",
  net: "Төлөнө турган",
  paid: "Төлөндү",
  due: "Төлөнө элек",
  received: "Алдым (кол тамга)",
  signAccountant: "Бухгалтер",
  signManager: "Жетекчи",
  signEmployee: "Кызматкер",
  timesheet: "Иш убактысынын табели",
  shiftsJournal: "Иш сменаларынын журналы",
  worked: "Иштеди, с",
  night: "Түнкү, с",
  shifts: "Смена",
  clockIn: "Башталышы",
  clockOut: "Аягы",
  breakMin: "Тыныгуу, мүн",
  hoursNote: "Убакыт саат жана мүнөт менен (с:мм); Excelде — ондук бөлчөк саат.",
  tipsSheet: "Чайпулду бөлүштүрүү ведомосту",
  tipsMode: "Бөлүштүрүү ыкмасы",
  tipsTotal: "Бардык чайпул",
  unassigned: "Бөлүштүрүлгөн жок",
  payout: "Төлөм",
  notPaid: "Төлөнгөн жок",
  employeesList: "Кызматкерлердин тизмеси",
  hiredAt: "Ишке кабыл алынган күнү",
  phone: "Телефон",
  email: "Email",
  payScheme: "Төлөм схемасы",
  working: "Иштейт",
  dismissed: "Бошотулган {{date}}",
  auditLog: "Аудит журналы",
  auditAt: "Күнү жана убактысы",
  action: "Аракет",
  user: "Ким",
  object: "Объект",
  section: "Бөлүм",
  allSections: "Бардык бөлүмдөр",
  pageN: "{{n}}-бет",
  leaderboard: "Кызматкерлердин рейтинги",
  rank: "Орун",
  metric: "Көрсөткүч",
  level: "Деңгээл",
  points: "Упай",
  allTime: "Бардык убакыт",
};

export const uz: Shape<typeof ru> = {
  branch: "Filial",
  employee: "Xodim",
  position: "Lavozim",
  period: "Davr",
  date: "Sana",
  status: "Holat",
  amount: "Summa",
  total: "Jami",
  payrollSheet: "To‘lov qaydnomasi",
  statement: "Qaydnoma",
  calculation: "Hisob v{{v}} · {{status}}",
  payslip: "Hisob varaqasi",
  payslips: "Hisob varaqalari",
  allPayslips: "Barcha varaqalar",
  component: "Turi",
  basis: "Asos",
  accrued: "Hisoblandi",
  withheld: "Ushlab qolindi",
  net: "To‘lanadi",
  paid: "To‘landi",
  due: "To‘lanishi qoldi",
  received: "Oldim (imzo)",
  signAccountant: "Buxgalter",
  signManager: "Rahbar",
  signEmployee: "Xodim",
  timesheet: "Ish vaqti tabeli",
  shiftsJournal: "Ish smenalari jurnali",
  worked: "Ishlangan, soat",
  night: "Tungi, soat",
  shifts: "Smenalar",
  clockIn: "Boshlanishi",
  clockOut: "Tugashi",
  breakMin: "Tanaffus, daq",
  hoursNote: "Vaqt soat va daqiqada (s:dd); Excelda — o‘nli kasr soatlarda.",
  tipsSheet: "Choychaqani taqsimlash qaydnomasi",
  tipsMode: "Taqsimlash usuli",
  tipsTotal: "Jami choychaqa",
  unassigned: "Taqsimlanmagan",
  payout: "To‘lov",
  notPaid: "To‘lanmagan",
  employeesList: "Xodimlar ro‘yxati",
  hiredAt: "Ishga qabul sanasi",
  phone: "Telefon",
  email: "Email",
  payScheme: "To‘lov sxemasi",
  working: "Ishlaydi",
  dismissed: "Bo‘shatilgan {{date}}",
  auditLog: "Audit jurnali",
  auditAt: "Sana va vaqt",
  action: "Amal",
  user: "Kim",
  object: "Obyekt",
  section: "Bo‘lim",
  allSections: "Barcha bo‘limlar",
  pageN: "{{n}}-sahifa",
  leaderboard: "Xodimlar reytingi",
  rank: "O‘rin",
  metric: "Ko‘rsatkich",
  level: "Daraja",
  points: "Ballar",
  allTime: "Butun vaqt",
};
